import {BpmnNodeCreatedResult} from '@ispm-client/modules/bpmn-modeler/models/bpmn-node-created-result';
import {TreatmentPlanSelectorResult} from '@ispm-client/modules/bpmn-modeler/models/treatment-plan-selector-result';
import {NodeCreationResult} from '@ispm-client/modules/bpmn-modeler/models/node-creation-result';
import {BpmnDeploymentIdentifier} from '@ispm-shared/modules/bpmn';
import {PathwaysAuthoringState} from '@ispm/shared/constants/pathways-authoring-state';
import {SaveParams} from '@ispm-client/modules/bpmn-modeler/models/save-params';
import {CommandStackAction} from '@ispm/shared/bpmn-io/commandstack-action';
import {NodeConfigurationResult} from '@ispm-client/modules/bpmn-modeler/store/actions';


export interface State {
    bpmnXml?: string;
    bpmnXmlGenerationError: string;
    bpmnIdentifier: BpmnDeploymentIdentifier;
    bpmnDeploymentError: string;
    nodesCreationInfo: Map<string, BpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult>>;
    userInitiatedActions: CommandStackAction[];
    floatedNodes?: Map<string, Array<string>>;
    nodesWithNotes: Set<string>;
    activeNodeNotesPanel: string;
    nodesConfigurations: { [nodeId: string]: string };
    saveParams: SaveParams;
    modelerState: PathwaysAuthoringState;
    lastNodeId: number;
    spinnerStatus: boolean;
    modelerContext: object;
    nodeConfigurationPanelState: Map<string, NodeConfigurationResult>;
    explorerViewCommand: string;
}

export const initialState: State = {
    bpmnXml: null,
    bpmnXmlGenerationError: null,
    bpmnDeploymentError: null,
    bpmnIdentifier: null,
    nodesCreationInfo: new Map<string, BpmnNodeCreatedResult<NodeCreationResult | TreatmentPlanSelectorResult>>(),
    userInitiatedActions: [],
    floatedNodes: new Map<string, Array<string>>(),
    nodesWithNotes: new Set<string>(),
    activeNodeNotesPanel: null,
    nodesConfigurations: {},
    saveParams: undefined,
    modelerState: undefined,
    lastNodeId: undefined,
    spinnerStatus: false,
    modelerContext: undefined,
    nodeConfigurationPanelState: new Map<string, NodeConfigurationResult>(),
    explorerViewCommand: undefined
};
